import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const updateCartButton = (btn, qty) => {
    // Find the add to cart button in the same container or nearby
    const wrapper = btn.closest('.product-actions-wrapper');
    if (wrapper) {
        const cartBtn = wrapper.querySelector('.add_to_cart_button');
        if (cartBtn) {
            cartBtn.dataset.quantity = qty;
        }
    }
};

const initQuantity = () => {
    // Minus
    clickOn(".qty-btn-minus", (e, btn) => {
        const input = btn.parentElement.querySelector(".quantity-input__field");
        let val = parseInt(input.value) || 1;
        if (val > 1) {
            val--;
            input.value = val;
            updateCartButton(btn, val);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    // Plus
    clickOn(".qty-btn-plus", (e, btn) => {
        const input = btn.parentElement.querySelector(".quantity-input__field");
        const max = parseInt(input.getAttribute('max')) || 9999;
        let val = parseInt(input.value) || 1;
        if (val < max) {
            val++;
            input.value = val;
            updateCartButton(btn, val);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
};

// Initialize on DOM ready
load(initQuantity);
